import { useState, useRef, useEffect } from "react";

if (typeof window !== 'undefined') {
  window.getTodaySerata = window.getTodaySerata || function () {
    console.warn("⚠️ getTodaySerata è stata chiamata ma non è definita sul server di Cloudflare!");
    return { data: [], success: false }; // o il valore di default che la tua app si aspetta
  };
}

// ─── OWL IMAGE (base64) ───────────────────────────────────────────────────
const OWL_B64 = "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";

const OWL_GIF = "./beccup_owl_transparent_1.gif";

// ─── SVG ICONS ────────────────────────────────────────────────────────────
const Icon = ({ name, size = 20, color = C.white, opacity = 1 }) => {
  const s = { width: size, height: size, display: "block", flexShrink: 0 };
  const paths = {
    home: <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H5a1 1 0 01-1-1V9.5z" fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />,
    fork: <><path d="M8 2v5a3 3 0 006 0V2M11 7v15" stroke={color} strokeWidth="1.5" strokeLinecap="round" /></>,
    music: <><path d="M9 18V6l12-2v12" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><circle cx="6" cy="18" r="3" stroke={color} strokeWidth="1.5" fill="none" /><circle cx="18" cy="16" r="3" stroke={color} strokeWidth="1.5" fill="none" /></>,
    cart: <><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke={color} strokeWidth="1.5" fill="none" strokeLinejoin="round" /><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke={color} strokeWidth="1.5" strokeLinecap="round" /></>,
    chat: <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" stroke={color} strokeWidth="1.5" fill="none" strokeLinejoin="round" />,
    bell: <><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0" stroke={color} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" /></>,
    belloff: <><path d="M13.73 21a2 2 0 01-3.46 0M1 1l22 22M8.56 2.9A6 6 0 0118 8c0 3.54-.88 5.95-1.75 7.5M6.53 6.53C6.19 7.24 6 8.1 6 9c0 7-3 9-3 9h14" stroke={color} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" /></>,
    chevron: <path d="M9 18l6-6-6-6" stroke={color} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />,
    plus: <path d="M12 5v14M5 12h14" stroke={color} strokeWidth="2" strokeLinecap="round" />,
    minus: <path d="M5 12h14" stroke={color} strokeWidth="2" strokeLinecap="round" />,
    trash: <><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" /></>,
    send: <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z" stroke={color} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />,
    star: <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" stroke={color} strokeWidth="1.5" fill="none" strokeLinejoin="round" />,
    mappin: <><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" stroke={color} strokeWidth="1.5" fill="none" /><circle cx="12" cy="10" r="3" stroke={color} strokeWidth="1.5" fill="none" /></>,
    info: <><circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" fill="none" /><path d="M12 16v-4M12 8h.01" stroke={color} strokeWidth="1.5" strokeLinecap="round" /></>,
    cocktail: <><path d="M8 22h8M12 22v-9M4 3l8 9 8-9H4z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" /></>,
    mic: <><rect x="9" y="2" width="6" height="11" rx="3" stroke={color} strokeWidth="1.5" fill="none" /><path d="M5 10a7 7 0 0014 0M12 19v3M8 22h8" stroke={color} strokeWidth="1.5" strokeLinecap="round" /></>,
    dj: <><circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" fill="none" /><circle cx="12" cy="12" r="3" stroke={color} strokeWidth="1.5" fill="none" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3" stroke={color} strokeWidth="1.5" strokeLinecap="round" /></>,
    grid: <><rect x="3" y="3" width="7" height="7" rx="1" stroke={color} strokeWidth="1.5" fill="none" /><rect x="14" y="3" width="7" height="7" rx="1" stroke={color} strokeWidth="1.5" fill="none" /><rect x="3" y="14" width="7" height="7" rx="1" stroke={color} strokeWidth="1.5" fill="none" /><rect x="14" y="14" width="7" height="7" rx="1" stroke={color} strokeWidth="1.5" fill="none" /></>,
    list: <><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" /></>,
    utensils: <><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 002-2V2" stroke={color} strokeWidth="1.5" strokeLinecap="round" /><path d="M7 2v20M21 15V2a5 5 0 00-5 5v6h3.5M16 22v-7" stroke={color} strokeWidth="1.5" strokeLinecap="round" fill="none" /></>,
    beer: <><path d="M17 11h1a3 3 0 010 6h-1" stroke={color} strokeWidth="1.5" strokeLinecap="round" fill="none" /><path d="M5 11h12v10a1 1 0 01-1 1H6a1 1 0 01-1-1V11z" stroke={color} strokeWidth="1.5" fill="none" /><path d="M5 7h12l-1.5 4H6.5L5 7zM9 5v2M12 4v3M15 5v2" stroke={color} strokeWidth="1.5" strokeLinecap="round" /></>,
    cake: <><path d="M20 21v-8a2 2 0 00-2-2H6a2 2 0 00-2 2v8" stroke={color} strokeWidth="1.5" fill="none" /><path d="M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2 1 2 1M2 21h20M12 8v3M12 8c0-1.1-.9-2-2-2" stroke={color} strokeWidth="1.5" strokeLinecap="round" /></>,
    pizza: <><path d="M12 2a10 10 0 000 20" stroke={color} strokeWidth="1.5" fill="none" strokeLinecap="round" /><path d="M12 2c2.8 0 5.3 1.1 7.1 2.9L12 22 4.9 4.9A10 10 0 0112 2z" stroke={color} strokeWidth="1.5" fill="none" /><circle cx="12" cy="11" r="1.5" fill={color} /></>,
    grill: <><path d="M4 6h16M4 10h16" stroke={color} strokeWidth="1.5" strokeLinecap="round" /><path d="M8 10v8a2 2 0 004 0v-8M12 10v8a2 2 0 004 0v-8" stroke={color} strokeWidth="1.5" strokeLinecap="round" /><path d="M6 6V4M18 6V4" stroke={color} strokeWidth="1.5" strokeLinecap="round" /></>,
    child: <><circle cx="12" cy="6" r="3" stroke={color} strokeWidth="1.5" fill="none" /><path d="M9 22V12H7l2-4h6l2 4h-2v10" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" /></>,
    clock: <><circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" fill="none" /><path d="M12 6v6l4 2" stroke={color} strokeWidth="1.5" strokeLinecap="round" /></>,
    dance: <><circle cx="12" cy="4" r="2" stroke={color} strokeWidth="1.5" fill="none" /><path d="M9 22l1-6-2-3 3-4 3 4-2 3 1 6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" /><path d="M7 12l-2 2M17 12l2 2" stroke={color} strokeWidth="1.5" strokeLinecap="round" /></>,
    fish: <><path d="M18 7l-2 2-2-2 2-2 2 2zM6 12c0-3.3 2.7-6 6-6h4l2 2-2 2h-4c-1.1 0-2 .9-2 2s.9 2 2 2h4l2 2-2 2h-4c-3.3 0-6-2.7-6-6z" stroke={color} strokeWidth="1.5" fill="none" strokeLinejoin="round" /></>,
    photo: <><rect x="3" y="5" width="18" height="14" rx="2" stroke={color} strokeWidth="1.5" fill="none" /><circle cx="12" cy="12" r="3" stroke={color} strokeWidth="1.5" fill="none" /><path d="M8 5l1-2h6l1 2" stroke={color} strokeWidth="1.5" strokeLinejoin="round" /></>,
    fire: <><path d="M12 2c0 0-5 4-5 9a5 5 0 0010 0c0-3-2-5-2-5s-.5 2-2 3c0-2-1-7-1-7z" stroke={color} strokeWidth="1.5" fill="none" strokeLinejoin="round" /></>,
    cashier: <><rect x="2" y="5" width="20" height="14" rx="2" stroke={color} strokeWidth="1.5" fill="none" /><path d="M2 10h20M7 15h.01M12 15h.01M17 15h.01" stroke={color} strokeWidth="1.5" strokeLinecap="round" /></>,
    group: <><circle cx="9" cy="7" r="3" stroke={color} strokeWidth="1.5" fill="none" /><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke={color} strokeWidth="1.5" fill="none" strokeLinecap="round" /><circle cx="17" cy="8" r="2.5" stroke={color} strokeWidth="1.5" fill="none" /><path d="M21 20c0-2.8-1.8-5.1-4.3-5.8" stroke={color} strokeWidth="1.5" fill="none" strokeLinecap="round" /></>,
  };
  return (
    <svg viewBox="0 0 24 24" style={{ ...s, opacity }} fill="none" xmlns="http://www.w3.org/2000/svg">
      {paths[name] || null}
    </svg>
  );
};

import SAGRA_DATA from "./data/sagra.json";



const SYSTEM_PROMPT = `Sei l'assistente Luigi Ciacolaufficiale della 46ª Sagra di San Luigi 2026, organizzata da BECCUP a Beccacivetta di Castel d'Azzano, dal 5 al 9 Giugno 2026.
Rispondi in italiano, in modo simpatico e informale come un volontario della sagra. Usa emoji. Sii conciso e utile.
ORARI: Stand dalle 19:30. Concerti ore 21:00 o 21:30. DJ set Fuori Sagra dalle 19:30. Baby Dance 19:30-20:30.
SERATE: Ven 5 DISCO FEVER 21:30 | Sab 6 CIRCOMAX 883 21:30 | Dom 7 Orch. MATTIA AGOSTINI 21:00 (AVIS) | Lun 8 Orch. LARA AGOSTINI 21:00 | Mar 9 DYNAMICA PARTY BAND 21:30.
Nel salone parrocchiale: pesca di beneficenza, mostre fotografiche 21 Megapixel e "I campi estivi parrocchiali ieri e oggi".
NOVITÀ: Arrosticini. Pizzeria Belsito (forno a legna).

MENÙ, BEVANDE E DOLCI:
${SAGRA_DATA.stands.map(s => "- " + s.nome + " (" + s.zona + "): " + s.piatti.map(p => p.nome + " €" + p.prezzo).join(', ') + (s.note ? " [Note: " + s.note + "]" : "")).join('\n')}

DOVE PAGARE (CASSE):
${SAGRA_DATA.casse.map(c => "- " + c.nome + " (" + c.zona + "): " + c.desc).join('\n')}`;

const SYSTEM_PROMPT_VENETO = `${SYSTEM_PROMPT}

IMPORTANTE: Devi rispondere ESCLUSIVAMENTE in dialetto veronese (veneto veronese). 
Usa espressioni tipiche come: "cossa", "vardà", "ghe xe", "par forsa", "dassé", "ostrega", "pota", "mama mia", "ndar", "vegnir", "magnà", "bevù", "bevar", "te digo", "el xe", "la xe", "vero?", "no xe", "parché", "cusina", "tosa/toso", "bel toso/tosa", ecc. 
Mantieni il tono simpatico e festoso da volontario della sagra, ma sempre in veronese! 🎉`;

const C = {
  bg: "#ffffff",
  bgDark: "#284c62",
  arancio: "#f39726ff",
  greenDk: "#6a8a1a",
  white: "#ffffff",
  wa: "rgba(255,255,255,0.06)",
  border: "rgba(255,255,255,0.08)",
  borderG: "rgba(141,181,42,0.3)",
  muted: "rgba(255,255,255,0.45)",
  dimmed: "rgba(255,255,255,0.2)",
  green: "#2dba51ff",
  fuori: "#284c62",   // fluo green for Fuori Sagra
};

// ─── WELCOME KEY ─────────────────────────────────────────────────────────
const WELCOME_KEY = "sagra_welcome_seen";
const NOTIF_SENT_KEY = "sagra_notif_sent";

function getLocalDateStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

function getTodaySerata() {
  return SAGRA_DATA.serate.find(s => s.data === getLocalDateStr()) || null;
}

function WelcomeModal({ onClose }) {
  const [step, setStep] = useState(0);
  const steps = [
    {
      title: "🎉 Benvenuto alla Sagra!",
      body: "L'app ufficiale della\n46ª Sagra di San Luigi 2026\nBeccacivetta di Castel d'Azzano!\nDal 5 al 9 Giugno 2026.\nCon l'app hai tutto il programma in tasca per non perderti nemmeno un secondo della festa.",
    },
    {
      title: "🍔 Consulta il Menù",
      body: "Scopri i nostri ricchi stand gastronomici:\nprimi, secondi, pizza al forno a legna, gustosi dolci, varie bevande e fiumi di birra 🍻.\nNovità : Arrivano gli ARROSTICINI!\n ... affrettatevi prima che finiscano! 🏃‍♂️💨",
    },
    {
      title: "🎶 Serate di musica",
      body: "5 serate di pura energia vi aspettano.\nSi comincia presto tutte le sere\ndalle 19:30 alle 20:30\ntutti i bimbi in pista con la Baby Dance!\nA seguire, la palla passa alle nostre fantastiche live band che vi faranno cantare e ballare fino alla fine.",
    },
    {
      title: "🔊 il FUORI SAGRA (TIHS RAB)",
      body: "Appuntamento fisso di ogni sera alle 19:30\nL'aperitivo ufficiale!\nGin pazzeschi pronti da gustare\nRitmo travolgente dei nostri DJ set per dare il via alla serata con il mood giusto!",
    },
    {
      title: "💡 'Vassoio Virtuale'",
      body: "Usa il calcolatore per simulare il tuo menu o quello del tavolo.\nZero calcoli mentali, zero dimenticanze: fai la tua scelta in relax e vai alla cassa senza pensieri.",
    },
    {
      title: "🤖 Chiedi all'Assistente",
      body: "Dubbi sulla Sagra? Chiedi a me!\nHai dubbi su orari, prezzi del menu, allergeni o piatti vegetariani? Scrivi qui la tua domanda!\n🫵 Scrivi come parli: capisco l'italiano e pure il dialetto veronese!\nProva subito a chiedermi quello che cerchi. Te speto!",
    },
  ];

  const current = steps[step];
  const isLast = step === steps.length - 1;

  // Font di sistema per adattarsi perfettamente ad iOS, Android e Desktop
  const systemFont = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 500, background: "rgba(0,0,0,0.82)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px 16px", animation: "fadeInOverlay .3s ease", fontFamily: systemFont }}>
      <style>{`@keyframes fadeInOverlay{from{opacity:0}to{opacity:1}}@keyframes popIn{from{opacity:0;transform:scale(.92) translateY(16px)}to{opacity:1;transform:scale(1) translateY(0)}}`}</style>

      <div
        style={{ background: "#fff", borderRadius: 22, width: "100%", maxWidth: 360, overflow: "hidden", animation: "popIn .3s cubic-bezier(.34,1.56,.64,1)", boxShadow: "0 24px 60px rgba(0,0,0,0.5)" }}
        onTouchStart={e => { e._swipeX = e.touches[0].clientX; }}
        onTouchEnd={e => {
          const dx = e.changedTouches[0].clientX - e._swipeX;
          if (Math.abs(dx) < 40) return;
          if (dx < 0 && !isLast) setStep(s => s + 1);
          if (dx > 0 && step > 0) setStep(s => s - 1);
        }}
      >
        {/* Header con maggiore spazio sotto il tasto Salta e logo allineato al titolo */}
        <div style={{ background: "#fff", padding: "50px 20px 12px", textAlign: "center", position: "relative" }}>
          <button onClick={onClose} style={{ position: "absolute", top: 14, right: 14, background: "transparent", border: `1.5px solid ${C.fuori}`, borderRadius: 12, padding: "4px 11px", fontFamily: systemFont, fontSize: "var(--font-meta)", fontWeight: 600, color: C.fuori, cursor: "pointer", letterSpacing: .5 }}>Salta</button>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            <div style={{ fontFamily: systemFont, fontWeight: 700, fontSize: "var(--font-hero)", color: C.green, lineHeight: 1.25 }}>{current.title}</div>
          </div>
        </div>

        {/* Body con spazio ridotto rispetto al titolo */}
        <div style={{ padding: "8px 22px 24px" }}>
          <div style={{ fontFamily: systemFont, fontSize: "var(--font-body)", color: "#284c62", lineHeight: 1.65, textAlign: "center", whiteSpace: "pre-line", minHeight: 80 }}>{current.body}</div>

          {/* Indicatori step */}
          <div style={{ display: "flex", justifyContent: "center", gap: 7, margin: "16px 0 20px" }}>
            {steps.map((_, i) => (
              <div key={i} style={{ width: i === step ? 20 : 7, height: 7, borderRadius: 4, background: i === step ? C.green : "rgba(40,76,98,0.18)", transition: "all .25s" }} />
            ))}
          </div>

          {/* Bottoni Navigazione */}
          <div style={{ display: "flex", gap: 8 }}>
            {step > 0 && (
              <button onClick={() => setStep(s => s - 1)} style={{ flex: 1, padding: "12px", borderRadius: 12, background: "transparent", border: "1.5px solid #284c62", fontFamily: systemFont, fontSize: "var(--font-body)", fontWeight: 700, color: "#284c62", cursor: "pointer" }}>← Indietro</button>
            )}
            <button onClick={() => isLast ? onClose() : setStep(s => s + 1)} style={{ flex: 2, padding: "12px", borderRadius: 12, background: "#284c62", border: "none", fontFamily: systemFont, fontSize: "var(--font-body)", fontWeight: 700, color: "#fff", cursor: "pointer" }}>
              {isLast ? "Inizia! 🎉" : "Avanti →"}
            </button>
          </div>
          {/* Crediti */}
          <div style={{ textAlign: "center", marginTop: 14 }}>
            <span style={{ fontFamily: systemFont, fontSize: "var(--font-small)", color: "rgba(40,76,98,0.3)", letterSpacing: 0.2 }}>
              App sviluppata da Marco Rossi · Maggio 2026
            </span>
          </div>
        </div>

      </div>
    </div>
  );
}

// ─── DAILY EVENT MODAL ────────────────────────────────────────────────────
function DailyEventModal({ onClose }) {
  const serata = getTodaySerata() || SAGRA_DATA.serate[0];

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 2000,
      background: "rgba(0,0,0,0.72)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: "16px",
    }}>
      <div style={{
        width: "100%", maxWidth: 400,
        background: "#fff",
        borderRadius: 22,
        overflow: "hidden",
        boxShadow: "0 8px 40px rgba(0,0,0,0.35)",
      }}>
        {/* Header */}
        <div style={{
          background: "#284c62",
          padding: "16px 18px",
          display: "flex", alignItems: "center", justifyContent: "space-between",
        }}>
          <div>
            <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-meta)", color: "#2dba51", fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 3 }}>
              🗓️ Stasera alla Sagra
            </div>
            <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-title)", fontWeight: 900, color: "#fff", lineHeight: 1.2 }}>
              {serata.giorno}
            </div>
          </div>
          <button onClick={onClose} style={{
            background: "rgba(255,255,255,0.12)", border: "none", borderRadius: "50%",
            width: 32, height: 32, fontSize: "var(--font-hero)", color: "#fff", cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>✕</button>
        </div>

        <div style={{ padding: "14px 16px 18px", display: "flex", flexDirection: "column", gap: 10 }}>

          {/* Card band — immagine a sx, testo a dx */}
          <div style={{
            background: "#f0f8f2", border: "1.5px solid #2dba51",
            borderRadius: 14, padding: "12px",
            display: "flex", alignItems: "center", gap: 12,
          }}>
            {serata.image && (
              <div style={{ width: 64, height: 64, borderRadius: 10, overflow: "hidden", flexShrink: 0, background: "#fff" }}>
                <img src={serata.image} alt={serata.artista}
                  style={{ width: "100%", height: "100%", objectFit: "contain" }} />
              </div>
            )}
            <div style={{ minWidth: 0 }}>
              <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-meta)", color: "#2dba51", fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 3 }}>
                🎤 Live sul palco · ore {serata.orario}
              </div>
              <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-title)", fontWeight: 900, color: "#284c62", lineHeight: 1.2 }}>
                {serata.artista}
              </div>
              <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-meta)", color: "#666", marginTop: 2 }}>{serata.genere}</div>
              {serata.note && (
                <div style={{ marginTop: 4, fontFamily: "sans-serif", fontSize: "var(--font-meta)", color: "#2dba51", fontWeight: 600 }}>⭐ {serata.note}</div>
              )}
            </div>
          </div>

          {/* Card DJ — identica struttura */}
          <div style={{
            background: "#eef3f7", border: "1.5px solid #284c62",
            borderRadius: 14, padding: "12px",
            display: "flex", alignItems: "center", gap: 12,
          }}>
            {serata.imageDj && (
              <div style={{ width: 64, height: 64, borderRadius: 10, overflow: "hidden", flexShrink: 0 }}>
                <img src={serata.imageDj} alt={serata.djset}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              </div>
            )}
            <div style={{ minWidth: 0 }}>
              <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-meta)", color: "#284c62", fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 3 }}>
                🔊 Fuori Sagra (TIHS RAB) · ore 19:30
              </div>
              <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-title)", fontWeight: 800, color: "#284c62" }}>{serata.djset}</div>
            </div>
          </div>

          {/* Bottone */}
          <button onClick={onClose} style={{
            width: "100%", padding: "13px",
            background: "#284c62", border: "none", borderRadius: 12,
            fontFamily: "sans-serif", fontSize: "var(--font-body)", fontWeight: 800,
            color: "#fff", cursor: "pointer", marginTop: 2,
          }}>🎉 Vai alla Sagra!</button>
        </div>
      </div>
    </div>
  );
}

// ─── NEW BADGE ────────────────────────────────────────────────────────────
function NewBadge({ small = false }) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center",
      background: "#e8001d",
      color: "#fff",
      borderRadius: 4,
      padding: small ? "1px 5px" : "2px 7px",
      fontSize: small ? 8 : 9,
      fontWeight: 800,
      fontFamily: "sans-serif",
      letterSpacing: 1,
      textTransform: "uppercase",
      marginLeft: 5,
      boxShadow: "0 1px 4px rgba(232,0,29,0.5)",
      flexShrink: 0,
    }}>NOVITÀ</span>
  );
}

// ─── ICON BOX ─────────────────────────────────────────────────────────────
function IconBox({ name, size = 18, fuori = false }) {
  return (
    <div style={{ width: 36, height: 36, borderRadius: 10, background: "#284c62", border: "1px solid #284c62", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
      <Icon name={name} size={size} color={C.green} opacity={1} />
    </div>
  );
}


// ─── NEWS PILLS (home) ────────────────────────────────────────────────────
const renderPills = (pillsArray) => (
  <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
    {pillsArray.map((p, i) => (
      <div key={i} style={{
        background: "#fff",
        borderRadius: 10,
        padding: "8px 10px",
        display: "flex",
        alignItems: "center",
        gap: 7,
        flexGrow: 1,
        minWidth: "calc(50% - 4px)",
        boxSizing: "border-box",
      }}>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-small)", color: "#2d7a00", lineHeight: 1, marginBottom: 2, textAlign: "left" }}>{p.value}</div>
          <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-meta)", fontWeight: 700, color: "#e28d1dff", lineHeight: 1.2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", textAlign: "left" }}>{p.label}</div>
        </div>
      </div>
    ))}
  </div>
);

function NewsCarousel() {
  const serata = (SAGRA_DATA.serate.find(s => s.data === (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` })()) || null) || SAGRA_DATA.serate[0];
  const slides = [
    { label: "Stand gastronomici", value: "Apertura ore 19:30" },
    { label: serata.artista, value: `Live sul palco · ore ${serata.orario}` },
    { label: "Baby Dance", value: "Palco principale · 19:30 – 20:30" },
    { label: serata.djset, value: "DJ Set al Fuori Sagra · ore 19:30" },
    { label: "Mostra '21 MEGAPIXEL'", value: "Stanze centro parrocchiale · ingresso libero" },
    { label: "Mostra fotografica 'I campi estivi parrocchiali ieri e oggi'", value: "Stanze centro parrocchiale · ingresso libero" },
    { label: "Pesca di beneficenza", value: "Salone parrocchiale" },
  ];

  const [idx, setIdx] = useState(0);
  const [anim, setAnim] = useState("in"); // "in" | "out"

  useEffect(() => {
    const timer = setInterval(() => {
      setAnim("out");
      setTimeout(() => {
        setIdx(i => (i + 1) % slides.length);
        setAnim("in");
      }, 320);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  const slide = slides[idx];

  return (
    <div style={{ marginBottom: 14 }}>
      <style>{`
        @keyframes slideInUp   { from { opacity:0; transform:translateY(10px) } to { opacity:1; transform:translateY(0) } }
        @keyframes slideOutUp  { from { opacity:1; transform:translateY(0)    } to { opacity:0; transform:translateY(-10px) } }
        .ns-in  { animation: slideInUp  .32s cubic-bezier(.4,0,.2,1) both }
        .ns-out { animation: slideOutUp .32s cubic-bezier(.4,0,.2,1) both }
      `}</style>

      {/* NewsCarousel strip */}
      <div style={{
        background: "rgba(249, 255, 198, 0.98)",
        border: "1px solid " + C.fuori,
        borderRadius: 14,
        padding: "12px 14px",
        display: "flex",
        flexDirection: "column",
        gap: 8,
        minHeight: 88,
        position: "relative",
      }}>

        {/* Content row */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", overflow: "hidden" }}>
          {/* Text */}
          <div key={idx} className={anim === "in" ? "ns-in" : "ns-out"} style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-carousel-value)", color: C.fuori, marginBottom: 3, textTransform: "uppercase", letterSpacing: 1.2 }}>
              {slide.value}
            </div>
            <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-carousel-label)", color: C.fuori, fontWeight: 900, lineHeight: 1.25, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {slide.label}
            </div>
          </div>

          {/* Dot indicators */}
          <div style={{ display: "flex", flexDirection: "column", gap: 4, flexShrink: 0 }}>
            {slides.map((_, i) => (
              <div
                key={i}
                onClick={() => { setAnim("out"); setTimeout(() => { setIdx(i); setAnim("in"); }, 320); }}
                style={{
                  width: i === idx ? 3 : 3,
                  height: i === idx ? 14 : 5,
                  borderRadius: 3,
                  background: i === idx ? C.green : C.fuori,
                  transition: "all .3s",
                  cursor: "pointer",
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── CASSA MODAL ──────────────────────────────────────────────────────────
function CassaModal({ onClose }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.72)", zIndex: 300, display: "flex", alignItems: "flex-end", justifyContent: "center" }} onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: "22px 22px 0 0", padding: "22px 18px 38px", width: "100%", maxWidth: "100%", animation: "slideUp .22s ease" }} onClick={e => e.stopPropagation()}>
        <div style={{ width: 34, height: 3, background: "rgba(40,76,98,0.2)", borderRadius: 2, margin: "0 auto 20px" }} />
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
          {/* Icona (Resta perfettamente al centro verticale grazie a alignItems: "center") */}
          <div style={{ width: 36, height: 36, borderRadius: 10, background: "rgba(243,151,38,0.1)", border: "1px solid rgba(243,151,38,0.25)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Icon name="cashier" size={18} color="#284c62" opacity={0.8} />
          </div>

          {/* Contenitore Testo modificato */}
          <div style={{ flex: 1, textAlign: "left" }}>
            <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-hero)", color: C.fuori, fontWeight: 700 }}>Guida al Pagamento</div>
            <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: C.fuori, marginTop: 2 }}>
              Evita i dubbi! Scopri come funziona la cassa. <br />(<strong>No pagamento in-app</strong>)
            </div>
          </div>
        </div>
        {/* CONTENITORE PRINCIPALE FLUIDO (Affianca Mosse e Casse) */}
        <div style={{ display: "flex", gap: 16, alignItems: "stretch", marginBottom: 16, background: "rgba(243,151,38,0.08)", border: "1px solid rgba(243,151,38,0.25)", borderRadius: 13, padding: "14px 16px" }}>

          {/* SEZIONE 4 MOSSE (Prende il 55% dello spazio disponibile) */}
          <div style={{ flex: "0 0 55%", textAlign: "left" }}>
            <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: C.fuori, fontWeight: 700, letterSpacing: 1.2, marginBottom: 8 }}>
              4 mosse e sei a tavola! 🚀
            </div>
            <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: "#284c62", lineHeight: 1.5, display: "flex", flexDirection: "column", gap: 8 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: "var(--font-title)" }}>🛒</span>
                <span>Scontrino alla <strong>cassa</strong></span>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: "var(--font-title)" }}>🎟️</span>
                <span>Prendi i <strong>biglietti</strong></span>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: "var(--font-title)" }}>🏃‍♂️</span>
                <span>Vai allo <strong>stand</strong></span>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: "var(--font-title)" }}>🍝</span>
                <span>Ritira e fai <strong>festa !!!</strong></span>
              </div>
            </div>
          </div>


          {/* SEZIONE CASSE IN VERTICALE (Prende il restante 45% dello spazio) */}
          <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
            <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: C.fuori, fontWeight: 700, letterSpacing: 1.2, marginBottom: 8 }}>
              Casse a disposizione :
            </div>
            {SAGRA_DATA.casse.map((c) => (
              <div key={c.id} style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", background: "rgba(40,76,98,0.03)", border: "1px solid rgba(40,76,98,0.1)", borderRadius: 10, padding: "6px 8px" }}>
                <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-meta)", color: "#284c62", fontWeight: 700, lineHeight: 1.1 }}>{c.nome} - {c.zona} </div>

                <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-small)", color: C.fuori, marginTop: 2, lineHeight: 1.2 }}>{c.desc}</div>
              </div>
            ))}
          </div>

        </div>

        <button onClick={onClose} style={{ width: "100%", background: "#284c62", border: "none", color: "#fff", fontFamily: "sans-serif", fontSize: "var(--font-body)", fontWeight: 700, cursor: "pointer", marginTop: 18, padding: "13px", borderRadius: 13 }}>
          Capito, grazie! 👍
        </button>
      </div>
    </div>
  );
}

// ── DEVE STARE QUI, fuori e PRIMA di SagraApp ──

function alreadySentToday() {
  const sent = JSON.parse(localStorage.getItem(NOTIF_SENT_KEY) || "{}");
  return !!sent[(() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` })()];
}
function markSentToday() {
  const sent = JSON.parse(localStorage.getItem(NOTIF_SENT_KEY) || "{}");
  sent[(() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` })()] = true;
  localStorage.setItem(NOTIF_SENT_KEY, JSON.stringify(sent));
}

// ─── ALLERGENI EU PANEL ────────────────────────────────────────────────────
const EU14 = [
  { key: "glutine", emoji: "🌾", label: "Cereali con glutine", desc: "Frumento, segale, orzo, avena, farro, kamut e derivati" },
  { key: "crostacei", emoji: "🦐", label: "Crostacei", desc: "Granchi, gamberi, aragoste e prodotti a base di crostacei" },
  { key: "uova", emoji: "🥚", label: "Uova", desc: "Uova e prodotti a base di uova" },
  { key: "pesce", emoji: "🐟", label: "Pesce", desc: "Pesce e prodotti a base di pesce" },
  { key: "arachidi", emoji: "🥜", label: "Arachidi", desc: "Arachidi e prodotti a base di arachidi" },
  { key: "soia", emoji: "🫘", label: "Soia", desc: "Soia e prodotti a base di soia" },
  { key: "latte", emoji: "🥛", label: "Latte", desc: "Latte e prodotti derivati (incluso lattosio)" },
  { key: "fruttasguscio", emoji: "🌰", label: "Frutta a guscio", desc: "Mandorle, nocciole, noci, anacardi, pistacchi ecc." },
  { key: "sedano", emoji: "🥬", label: "Sedano", desc: "Sedano e prodotti a base di sedano" },
  { key: "senape", emoji: "🟡", label: "Senape", desc: "Senape e prodotti a base di senape" },
  { key: "sesamo", emoji: "🌱", label: "Semi di sesamo", desc: "Semi di sesamo e prodotti a base di sesamo" },
  { key: "solfiti", emoji: "🍷", label: "Anidride solforosa e solfiti", desc: "Concentrazioni > 10 mg/kg o 10 mg/l" },
  { key: "lupini", emoji: "🌿", label: "Lupini", desc: "Lupini e prodotti a base di lupini" },
  { key: "molluschi", emoji: "🦑", label: "Molluschi", desc: "Molluschi e prodotti a base di molluschi" },
];

function AllergeniModal({ onClose }) {
  const C = "#284c62";
  const presenti = EU14.filter(a =>
    SAGRA_DATA.stands.some(s => s.piatti.some(p => (p.allergeni || []).includes(a.key)))
  );
  const assenti = EU14.filter(a => !presenti.includes(a));
  const Pill = ({ a, faded }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 4, padding: "4px 8px", borderRadius: 8, background: faded ? "rgba(40,76,98,0.04)" : "rgba(40,76,98,0.08)", border: `1px solid ${faded ? "rgba(40,76,98,0.08)" : "rgba(40,76,98,0.18)"}`, opacity: faded ? 0.38 : 1 }}>
      <span style={{ fontSize: "var(--font-body)" }}>{a.emoji}</span>
      <span style={{ fontSize: "var(--font-meta)", color: C, fontWeight: 600 }}>{a.label}</span>
    </div>
  );
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 600, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", padding: "0 16px" }}
      onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 18, width: "100%", maxWidth: 480, maxHeight: "80vh", display: "flex", flexDirection: "column", animation: "slideUp .25s cubic-bezier(.34,1.1,.64,1)", fontFamily: "sans-serif" }}
        onClick={e => e.stopPropagation()}>
        <style>{`@keyframes slideUp{from{transform:translateY(100%)}to{transform:translateY(0)}}`}</style>
        <div style={{ padding: "8px 14px 10px", borderBottom: "1px solid rgba(40,76,98,0.1)" }}>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 6 }}>
            <div style={{ width: 32, height: 3.5, borderRadius: 2, background: "rgba(40,76,98,0.15)" }} />
          </div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ fontSize: "var(--font-body)", fontWeight: 800, color: C, textTransform: "uppercase", textAlign: "center", letterSpacing: 0.4 }}>⚠️ Allergeni · Reg. UE 1169/2011</div>
            <button onClick={onClose} style={{ background: "rgba(40,76,98,0.08)", border: "none", borderRadius: 8, width: 26, height: 26, cursor: "pointer", fontSize: "var(--font-body)", color: C }}>✕</button>
          </div>
        </div>
        <div style={{ overflowY: "auto", padding: "10px 14px 20px" }}>
          <div style={{ fontSize: "var(--font-meta)", fontWeight: 700, color: C, textTransform: "uppercase", letterSpacing: 0.8, opacity: 0.5, marginBottom: 7 }}>Presenti in sagra</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 14 }}>
            {presenti.map(a => <Pill key={a.key} a={a} faded={false} />)}
          </div>
          <div style={{ fontSize: "var(--font-meta)", fontWeight: 700, color: C, textTransform: "uppercase", letterSpacing: 0.8, opacity: 0.4, marginBottom: 7 }}>Non presenti</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            {assenti.map(a => <Pill key={a.key} a={a} faded={true} />)}
          </div>
          <div style={{ fontSize: "var(--font-meta)", color: C, opacity: 0.4, marginTop: 12, lineHeight: 1.4, textAlign: "center" }}>
            Info indicative — per allergie gravi contatta gli organizzatori.
          </div>
        </div>
      </div>
    </div>
  );
}

function AllergeniPanel({ onOpen }) {
  const C_fuori = "#284c62";
  return (
    <div style={{ marginTop: 10, marginBottom: 8 }}>
      <button
        onClick={onOpen}
        style={{ width: "100%", background: "rgba(40,76,98,0.05)", border: "1px solid rgba(40,76,98,0.2)", borderRadius: 12, padding: "10px 14px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, fontFamily: "sans-serif" }}
      >
        <span style={{ fontSize: "var(--font-body)" }}>⚠️</span>
        <span style={{ fontSize: "var(--font-body)", fontWeight: 700, color: C_fuori, textTransform: "uppercase", letterSpacing: 0.5 }}>Informazioni sugli Allergeni</span>
        <span style={{ fontSize: "var(--font-meta)", color: C_fuori, opacity: 0.55 }}>Reg. UE 1169/2011</span>
      </button>
    </div>
  );
}

// ─── MAIN APP ──────────────────────────────────────────────────────────────
export default function SagraApp() {
  const [tab, setTab] = useState("home");
  const [carrello, setCarrello] = useState([]);
  const [aperto, setAperto] = useState(null);
  const [serateView, setSerateView] = useState("list");
  const [showCasseModal, setShowCasseModal] = useState(false);
  const [showAllergeniModal, setShowAllergeniModal] = useState(false);
  const [showWelcome, setShowWelcome] = useState(() => !localStorage.getItem(WELCOME_KEY));
  const [showDaily, setShowDaily] = useState(true);
  const [djView, setDjView] = useState("grid");
  const [chatMessages, setChatMessages] = useState([
    { role: "assistant", content: "Ciao sono Luigi CIACOLA!\nBenvenuto alla 46ª Sagra di San Luigi 2026.\nSono il tuo assistente.\nChiedimi tutto: menù, prezzi, dove trovare cosa, chi suona stasera..." },
  ]);
  const [chatInput, setChatInput] = useState("");
  const [chatLoading, setChatLoading] = useState(false);
  const chatEndRef = useRef(null);

  useEffect(() => { chatEndRef.current?.scrollIntoView({ behavior: "smooth" }); }, [chatMessages]);

  const addToCarrello = (standNome, piatto) =>
    setCarrello(prev => {
      const ex = prev.find(i => i.nome === piatto.nome && i.stand === standNome);
      if (ex) return prev.map(i => i.nome === piatto.nome && i.stand === standNome ? { ...i, qty: i.qty + 1 } : i);
      return [...prev, { ...piatto, stand: standNome, qty: 1 }];
    });

  const removeFromCarrello = (nome, stand) =>
    setCarrello(prev => {
      const ex = prev.find(i => i.nome === nome && i.stand === stand);
      if (ex?.qty === 1) return prev.filter(i => !(i.nome === nome && i.stand === stand));
      return prev.map(i => i.nome === nome && i.stand === stand ? { ...i, qty: i.qty - 1 } : i);
    });

  const getQty = (nome, stand) => carrello.find(i => i.nome === nome && i.stand === stand)?.qty || 0;
  const totale = carrello.reduce((s, i) => s + i.prezzo * i.qty, 0);
  const totPezzi = carrello.reduce((s, i) => s + i.qty, 0);
  const fmtP = p => `${p % 1 === 0 ? p : p.toFixed(2).replace(".", ",")} €`;
  const [dialectMode, setDialectMode] = useState(false);

  const sendChat = async () => {
    const msg = chatInput.trim();
    if (!msg || chatLoading) return;
    setChatInput("");
    const newMsgs = [...chatMessages, { role: "user", content: msg }];
    setChatMessages(newMsgs);
    setChatLoading(true);

    try {
      const activePrompt = dialectMode ? SYSTEM_PROMPT_VENETO : SYSTEM_PROMPT;

      // Groq usa il formato OpenAI: array di { role, content }
      const messages = newMsgs.map(m => ({
        role: m.role,       // "user" | "assistant" — già compatibili
        content: m.content
      }));

      const res = await fetch("/groqChat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          systemPrompt: activePrompt,
          messages: messages
        })
      });

      const data = await res.json();

      if (data.error) {
        setChatMessages([...newMsgs, { role: "assistant", content: "Errore API Groq: " + data.error.message }]);
      } else {
        // Formato OpenAI-compatible: choices[0].message.content
        const reply = data.choices?.[0]?.message?.content || "Non ho capito, riprova!";
        setChatMessages([...newMsgs, { role: "assistant", content: reply }]);
      }
    } catch (e) {
      setChatMessages([...newMsgs, { role: "assistant", content: "Errore di connessione." }]);
    }
    setChatLoading(false);
  };

  const navTabs = [
    { id: "home", icon: "home", label: "Home" },
    { id: "menu", icon: "fork", label: "Menù" },
    { id: "fuori_sagra", icon: "beer", label: "TIHS RAB" },
    { id: "serate", icon: "music", label: "Serate" },
    { id: "carrello", icon: "cart", label: "Spesa" },
    { id: "chat", icon: "chat", label: "Chiedi" },
  ];

  // ─── ALLERGENI CONFIG ────────────────────────────────────────────────────
  const ALLERGENI_INFO = {
    glutine: { emoji: "🌾", label: "Glutine" },
    crostacei: { emoji: "🦐", label: "Crostacei" },
    uova: { emoji: "🥚", label: "Uova" },
    pesce: { emoji: "🐟", label: "Pesce" },
    arachidi: { emoji: "🥜", label: "Arachidi" },
    soia: { emoji: "🫘", label: "Soia" },
    latte: { emoji: "🥛", label: "Latte" },
    fruttasguscio: { emoji: "🌰", label: "Frutta a guscio" },
    sedano: { emoji: "🥬", label: "Sedano" },
    senape: { emoji: "🟡", label: "Senape" },
    sesamo: { emoji: "🌱", label: "Sesamo" },
    solfiti: { emoji: "🍷", label: "Solfiti" },
    lupini: { emoji: "🌿", label: "Lupini" },
    molluschi: { emoji: "🦑", label: "Molluschi" },
  };

  const PiattoRow = ({ piatto, standNome }) => {
    const qty = getQty(piatto.nome, standNome);
    const hasAllergeni = piatto.allergeni && piatto.allergeni.length > 0;
    return (
      <div className="row" style={{ alignItems: "center" }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: "#284c62", lineHeight: 1.4, textAlign: "left" }}>{piatto.nome}</div>
            {piatto.isNew && <NewBadge small />}
          </div>
          {hasAllergeni && (
            <button
              onClick={e => { e.stopPropagation(); setShowAllergeniModal(true); }}
              style={{ background: "none", border: "none", padding: 0, cursor: "pointer", display: "flex", alignItems: "center", gap: 3, marginTop: 1, textAlign: "left" }}
            >
              <span style={{ fontFamily: "sans-serif", fontSize: "var(--font-meta)", color: "#284c62", opacity: 0.5 }}>(allergeni</span>
              {piatto.allergeni.map(a => {
                const info = ALLERGENI_INFO[a];
                return info ? <span key={a} style={{ fontSize: "var(--font-meta)", lineHeight: 1 }}>{info.emoji}</span> : null;
              })}
              <span style={{ fontFamily: "sans-serif", fontSize: "var(--font-meta)", color: "#284c62", opacity: 0.5 }}>)</span>
            </button>
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
          <span style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", fontWeight: 700, color: C.fuori }}>{fmtP(piatto.prezzo)}</span>
          {qty > 0 ? (
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <button className="qbtn" onClick={() => removeFromCarrello(piatto.nome, standNome)}><Icon name="minus" size={13} color={C.white} /></button>
              <span style={{ fontFamily: "sans-serif", fontWeight: 700, fontSize: "var(--font-title)", minWidth: 18, textAlign: "center", color: "#284c62" }}>{qty}</span>
              <button className="qbtn" onClick={() => addToCarrello(standNome, piatto)}><Icon name="plus" size={13} color={C.white} /></button>
            </div>
          ) : (
            <button className="qbtn" onClick={() => addToCarrello(standNome, piatto)}><Icon name="plus" size={13} color={C.white} /></button>
          )}
        </div>
      </div>
    );
  };

  const PageTitle = ({ children, style = {}, rightElement = null }) => (
    <div style={{ display: "flex", alignItems: "center", marginBottom: 16, marginTop: 0, position: "relative" }}>
      <button onClick={() => setTab("home")} style={{ background: C.white, border: `1px solid ${C.fuori}`, borderRadius: 10, cursor: "pointer", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, position: "absolute", left: 0 }} title="Torna alla Home">
        <div style={{ transform: "rotate(180deg)", display: "flex" }}>
          <Icon name="chevron" size={16} color={C.fuori} />
        </div>
      </button>
      <div style={{ flex: 1, fontFamily: "sans-serif", fontSize: "var(--font-hero)", color: C.green, fontWeight: 700, textAlign: "center", paddingLeft: 40, paddingRight: 40, ...style }}>
        {children}
      </div>
      {rightElement && (
        <div style={{ position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center" }}>
          {rightElement}
        </div>
      )}
    </div>
  );

  return (
    <div style={{ fontFamily: "sans-serif", width: "100%", maxWidth: "100%", height: "100vh", height: "100dvh", background: C.bg, color: C.white, display: "flex", flexDirection: "column", overflow: "hidden", position: "relative" }}>
      <style>{`
        :root {
          --font-hero:  clamp(15px, 4.2vw, 21px);
          --font-title: clamp(13px, 3.5vw, 17px);
          --font-body:  clamp(11.5px, 3vw, 14.5px);
          --font-meta:  clamp(9px, 2.4vw, 12px);
          --font-small: clamp(7.5px, 1.9vw, 9.5px);
          --font-carousel-label: clamp(16px, 4.5vw, 22px);
          --font-carousel-value: clamp(9px, 2.5vw, 12px);
        }
        html, body, #root { overflow: hidden; height: 100%; }
        *{box-sizing:border-box;margin:0;padding:0}
        ::-webkit-scrollbar{width:3px}::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.1);border-radius:2px}
        .card{background:#fff;border:1px solid #284c62;border-radius:14px;padding:11px;margin-bottom:8px}
        .btn{background:#284c62;color:#fff;border:none;border-radius:9px;padding:7px 14px;font-weight:700;font-family:sans-serif;cursor:pointer;font-size:13px;transition:opacity .15s}
        .btn:active{opacity:.75}
        .badge{background:rgba(141,181,42,0.12);color:${C.green};border:1px solid rgba(141,181,42,0.25);border-radius:20px;padding:3px 10px;font-size:10px;font-weight:600;font-family:sans-serif;letter-spacing:.4px;display:inline-flex;align-items:center;gap:5px}
        .qbtn{background:#284c62;border:1px solid rgba(40,76,98,0.4);color:#fff;border-radius:8px;width:29px;height:29px;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:opacity .1s}
        .qbtn:active{opacity:.7}
        input{background:rgba(255,255,255,.05);border:1px solid ${C.border};border-radius:11px;color:#fff;font-family:sans-serif;font-size:16px;outline:none;padding:10px 14px;width:100%;-webkit-appearance:none}
        input::placeholder{color:${C.muted}}
        input:focus{border-color:rgba(141,181,42,0.5)}
        .chat-u{background:linear-gradient(135deg,${C.green},${C.greenDk});color:#fff;border-radius:18px 18px 4px 18px;padding:10px 14px;max-width:80%;margin-left:auto;font-family:sans-serif;font-size:13px;line-height:1.55;white-space:pre-wrap}
        .chat-a{background:${C.wa};border:1px solid ${C.border};color:rgba(255,255,255,0.88);border-radius:18px 18px 18px 4px;padding:10px 14px;max-width:88%;font-family:sans-serif;font-size:13px;line-height:1.55;white-space:pre-wrap}
        .pill{background:rgba(255,255,255,.04);border:1px solid ${C.border};color:${C.muted};border-radius:20px;padding:5px 12px;font-size:11px;font-family:sans-serif;cursor:pointer;white-space:nowrap;flex-shrink:0;transition:background .1s}
        .pill:active{background:rgba(255,255,255,.09)}
        .blink{animation:b 1.2s infinite;display:inline-block}
        @keyframes b{0%,100%{opacity:.15}50%{opacity:1}}
        .row{display:flex;align-items:center;justify-content:space-between;padding:8px 0;border-bottom:1px solid rgba(40,76,98,0.1);gap:8px}
        .row:last-child{border-bottom:none}
        .scard{background:#fff;border:1px solid #284c62;border-radius:14px;padding:14px;margin-bottom:9px}
        @keyframes slideUp{from{transform:translateY(100%)}to{transform:translateY(0)}}
        .fuori-card{background:${C.wa};border:1.5px solid rgba(57,255,20,0.45);border-radius:14px;margin-bottom:8px;overflow:hidden}
        .casse-box{background:rgba(20,30,60,0.7);border:1px solid rgba(141,181,42,0.25);border-radius:13px;padding:14px;margin-top:14px}
      `}</style>

      {/* ── HEADER ── */}
      <div style={{ background: C.bgDark, padding: "14px 14px 11px", borderBottom: `1px solid ${C.border}`, flexShrink: 0, width: "100%" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 5, flexShrink: 0 }}>
            {/* OWL LOGO — click to reset tutorial */}
            <img
              src="/beccup_trasparente.png"
              alt="BECCUP"
              style={{ width: 80, height: 60, objectFit: "fill", flexShrink: 0, cursor: "pointer" }}
              onClick={() => { localStorage.removeItem(WELCOME_KEY); setShowWelcome(true); }}
              title="Tutorial"
            />
            {/* SOCIAL ICONS */}
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <a href="https://www.facebook.com/Faisagraconnoi" target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 7, background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)" }}>
                <svg viewBox="0 0 24 24" width="15" height="15" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/fai_sagra_con_noi/?hl=it" target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 7, background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)" }}>
                <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.5" cy="6.5" r="1" fill="#fff" stroke="none" />
                </svg>
              </a>
            </div>
          </div>
          <div style={{ flex: 1, textAlign: "center" }}>
            <div style={{ fontSize: "var(--font-title)", fontWeight: 900, letterSpacing: 3.5, color: C.green, fontFamily: "sans-serif", textTransform: "uppercase", marginBottom: 3 }}>{SAGRA_DATA.edizione}</div>
            <div style={{ fontFamily: "sans-serif", fontWeight: 900, fontSize: "var(--font-title)", color: C.green, lineHeight: 1.2, letterSpacing: .3 }}>{SAGRA_DATA.nome}</div>
            <div style={{ fontSize: "var(--font-meta)", color: C.white, fontFamily: "sans-serif", marginTop: 3 }}>{SAGRA_DATA.luogo}</div>
            <div style={{ fontSize: "var(--font-body)", fontWeight: 700, color: C.white, fontFamily: "sans-serif", marginTop: 3 }}>{SAGRA_DATA.date}</div>
          </div>
          {/* PATROCINIO LOGO & TEXT */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", flexShrink: 0, marginLeft: 4 }}>
            <img
              src="/patrocinio.png"
              alt="Patrocinio"
              style={{ height: 32, objectFit: "fill", marginBottom: 3 }}
            />
            <div style={{ fontSize: "var(--font-small)", color: C.white, fontFamily: "sans-serif", textAlign: "right", lineHeight: 1.15, opacity: 0.8 }}>
              Con il patrocinio di<br />
              Città di<br />
              Castel d'Azzano
            </div>
          </div>
        </div>
      </div>

      {/* ── CONTENT ── */}
      <div style={{ flex: 1, overflowY: tab === "chat" ? "hidden" : "auto", minHeight: 0, padding: tab === "chat" ? "12px 12px 0" : "12px 12px 20px", width: "100%", WebkitOverflowScrolling: "touch", display: "flex", flexDirection: "column" }}>

        {/* ── HOME ── */}
        {tab === "home" && (() => {
          const todayS = (SAGRA_DATA.serate.find(s => s.data === (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` })()) || null);
          const homeCards = [
            { icon: "fork", title: "Menù & Stand", sub: "Primi, secondi, pizza al forno a legna, arrosticini, dolci e bevande", action: "menu", isNew: true },
            { icon: "cocktail", title: "il FUORI SAGRA (TIHS RAB)", sub: "Aperitivo dalle 19:30 con DJ set", action: "fuori_sagra", fuori: true, staseraLabel: todayS ? `${todayS.djset} · 19:30` : null },
            { icon: "music", title: "Serate & Concerti", sub: "5 serate con musica dal vivo", action: "serate", staseraLabel: todayS ? `${todayS.artista} · ore ${todayS.orario}` : null },
            { icon: "chat", title: "Chiedi all'Assistente", sub: "Vegetariano? Prezzi? Chi suona? Chiedimi!", action: "chat" },
            { icon: "cart", title: "Stima qui la Spesa", sub: totPezzi > 0 ? `${totPezzi} piatti · €${totale.toFixed(2)}` : "Aiuto pratico per calcolare le spese prima di andare in cassa.", action: "carrello" },
            { icon: "group", title: "Associazioni", sub: "Le realtà che la sagra sostiene", action: "associazioni" }
          ];
          return (
            <div>
              <NewsCarousel />
              {homeCards.map(homecard => (
                <div key={homecard.action}
                  style={{
                    display: "flex", alignItems: "center", gap: 11, cursor: "pointer",
                    ...(homecard.fuori ? {
                      background: C.wa, border: `2px solid #284c62`,
                      borderRadius: 14, padding: "11px", marginBottom: 8,
                    } : {
                      background: "#fff", border: "1px solid #284c62",
                      borderRadius: 14, padding: "11px", marginBottom: 8,
                    }),
                  }}
                  onClick={() => setTab(homecard.action)}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-title)", color: homecard.fuori ? C.fuori : C.green, fontWeight: 700, textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, textTransform: "uppercase", flexWrap: "wrap" }}>
                      {homecard.action === "chat" && (
                        <img src={OWL_GIF} alt="Luigi AI" style={{ background: C.fuori, width: 36, height: 36, objectFit: "contain", flexShrink: 0, borderRadius: 6 }} />
                      )}
                      {homecard.title}
                    </div>
                    <div style={{ fontSize: "var(--font-body)", color: "#284c62", fontFamily: "sans-serif", marginTop: 2, textAlign: "center" }}>{homecard.sub}</div>
                  </div>
                  <Icon name="chevron" size={17} color={homecard.fuori ? C.fuori : "#284c62"} opacity={homecard.fuori ? 0.7 : 0.6} />
                </div>
              ))}
            </div>
          );
        })()}

        {/* ── MENU ── */}
        {tab === "menu" && (
          <div style={{ width: "100%" }}>
            <PageTitle rightElement={
              <button onClick={() => setShowAllergeniModal(true)} style={{ background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: 4, padding: "4px 6px", borderRadius: 8 }} title="Allergeni">
                <Icon name="info" size={16} color="#284c62" opacity={0.6} />
                <span style={{ fontFamily: "sans-serif", fontSize: "var(--font-meta)", color: "#284c62", opacity: 0.6, fontWeight: 600 }}>Allergeni</span>
              </button>
            }>MENU' & STAND</PageTitle>
            {SAGRA_DATA.stands.map(stand => {
              const isOpen = aperto === stand.id;
              const isFuori = stand.id === 7;
              const isPizza = stand.id === 8;
              const isArros = stand.id === 3;
              return (
                <div key={stand.id} style={{
                  padding: 0, overflow: "hidden", marginBottom: 8, borderRadius: 14,
                  ...(isFuori
                    ? { background: C.wa, border: `1.5px solid #284c62` }
                    : (isNew => isNew
                      ? { background: "#fff", border: `1.5px solid rgba(232, 0, 27, 1)` }
                      : { background: "#fff", border: `1px solid #284c62` })(stand.isNew)),
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 12px", cursor: "pointer", position: "relative" }} onClick={() => setAperto(isOpen ? null : stand.id)}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-hero)", color: C.fuori, fontWeight: 700, textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, flexWrap: "wrap", textTransform: "uppercase" }}>
                        <span>{stand.nome}</span>
                        {isPizza && (
                          <div style={{ width: 80, height: 50, borderRadius: 6, overflow: "hidden", flexShrink: 0, background: "#2a1a0a", display: "flex", alignItems: "center", justifyContent: "center", border: `1px solid rgba(255,180,50,0.3)` }}>
                            <img src="/belsito-logo.png" alt="Belsito" style={{ width: "100%", height: "100%", objectFit: "fill" }} />
                          </div>
                        )}
                        {stand.isNew && <NewBadge />}
                      </div>
                      <div style={{ fontSize: "var(--font-meta)", color: C.fuori, fontFamily: "sans-serif", marginTop: 2, display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
                        <Icon name="mappin" size={12} color={C.fuori} opacity={0.8} />{stand.zona}
                      </div>
                    </div>
                    <div style={{
                      transition: "transform .2s",
                      transform: isOpen ? "rotate(90deg)" : "none",
                      flexShrink: 0,
                      position: "absolute",
                      right: 14,
                      top: "50%",
                      transform: `translateY(-50%) ${isOpen ? "rotate(90deg)" : ""}`
                    }}>
                      <Icon name="chevron" size={17} color={isFuori ? C.fuori : "#284c62"} opacity={0.7} />
                    </div>
                  </div>
                  {isOpen && (
                    <div style={{ padding: "3px 12px 11px" }}>
                      {/* Pizzeria Belsito special block */}
                      {isPizza && (
                        <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: "var(--font-body)", color: C.fuori, fontFamily: "sans-serif", padding: "7px 0 10px", fontStyle: "italic", borderBottom: "1px solid ${C.fuori}", marginBottom: 8 }}>
                          <span>🍕 Pizza cotta in forno a legna</span>
                        </div>
                      )}
                      {stand.note && (
                        <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: "var(--font-body)", color: C.fuori, fontFamily: "sans-serif", padding: "7px 0 3px", fontStyle: "italic" }}>
                          <Icon name="info" size={11} color={C.fuori} opacity={0.8} />{stand.note}
                        </div>
                      )}
                      {stand.piatti.map((p, i) => <PiattoRow key={i} piatto={p} standNome={stand.nome} />)}
                    </div>
                  )}
                </div>
              );
            })}

            {/* ── RIEPILOGO 14 ALLERGENI EU ── */}

          </div>
        )}

        {/* ── FUORI SAGRA standalone ── */}
        {tab === "fuori_sagra" && (
          <div style={{ width: "100%" }}>
            <PageTitle style={{ color: C.fuori }}>il Fuori Sagra (TIHS RAB)</PageTitle>
            {(() => {
              const stand = SAGRA_DATA.stands.find(s => s.id === 7);
              const GIN_NOMI = ["Gin Tonic Standard", "Gin Tonic Premium"];
              const piattiBar = stand.piatti.filter(p => !GIN_NOMI.includes(p.nome));
              const GIN_CORNER = [
                { nome: "GIN MARE", tag: "Premium", prezzo: 10, desc: "Arditamente saporito esplode in ginepro e coriandolo fresco per poi trasfomarsi in note speziate ed erbacee.", img: "/gin/gin_mare_2.png" },
                { nome: "BULLDOG", tag: "Premium", prezzo: 10, desc: "Sprigiona: iris selvatico, limone e lavanda mentre in bocca è elegante invitante ed avvolgente con buona freschezza ed aromaticità.", img: "/gin/bulldog_2.png" },
                { nome: "GIN DEL PROFESSORE", tag: "Premium", prezzo: 10, desc: "I profumi di cannella, vaniglia, noce moscata, pepe, miele e pesche mature sono perfettamente bilanciati dal profumo di agraumi dell'arancia e della buccia di limone e da una nota balsamica leggera finale. Il sorso è inevitabilmente caldo, sapido e balsamico, con un finale disteso e resinonso, completato da note floreali.", img: "/gin/gin_professore_2.png" },
                { nome: "HENDRICK'S", tag: "Premium", prezzo: 10, desc: "Unisce il ginepro e le classiche erbe aromatiche a insolite infusioni di petali rosa bulgara ed essenza di cetriolo tedesco", img: "/gin/hendricks_2.png" },
                { nome: "NORDES", tag: "Premium", prezzo: 10, desc: "Il Gin Nordés è un distillato spagnoalo nato nell'affascinante Galizia grazie a un mix di 'botanicals' locali, lavorate con sapienza. Un Gin dal profilo unico, distante dai classici gin che saturano il mercato, fortemente identitario.", img: "/gin/nordes_2.png" },
                { nome: "ROKU", tag: "Premium", prezzo: 10, desc: "Un Gin dal profumo di fiori di ciliegio e tè verde che forniscono un aroma floreale e dolce. In bocca il sapore è complesso, stratificato, ma armonico.", img: "/gin/roku_2.png" },
                { nome: "MONKEY 47", tag: "Premium", prezzo: 10, desc: "Avvolge il palato di ginepro e arrichisce il gusto con note balsamiche di pino, menta piperita, lavanda, sentori di agrumi con finale leggermente amaro.", img: "/gin/monkey47_2.png" },
              ];
              return (
                <>
                  {/* DRINK & BAR */}
                  <div style={{ padding: 0, overflow: "hidden", marginBottom: 8, borderRadius: 14, background: "#fff", border: `1.5px solid ${C.fuori}` }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "10px 12px", cursor: "pointer", position: "relative" }} onClick={() => setAperto(aperto === "drink" ? null : "drink")}>
                      <div>
                        <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-title)", color: "#284c62", fontWeight: 700, textAlign: "center" }}>DRINK & BAR</div>
                        <div style={{ fontSize: "var(--font-meta)", color: C.fuori, fontFamily: "sans-serif", marginTop: 2, textAlign: "center" }}>Cocktail · Aperitivo · Birre</div>
                      </div>
                      <div style={{ position: "absolute", right: 14, top: "50%", transform: `translateY(-50%) ${aperto === "drink" ? "rotate(90deg)" : ""}`, transition: "transform .2s" }}>
                        <Icon name="chevron" size={17} color="#284c62" opacity={0.7} />
                      </div>
                    </div>
                    {aperto === "drink" && (
                      <div style={{ padding: "0 12px 12px" }}>
                        {stand.note && (
                          <div style={{ display: "flex", alignItems: "flex-start", gap: 6, fontSize: "var(--font-body)", color: C.fuori, fontFamily: "sans-serif", marginBottom: 10, fontStyle: "italic", lineHeight: 1.7, marginTop: 8 }}>
                            <Icon name="info" size={11} color="#6b8fa8" opacity={0.8} />{stand.note}
                          </div>
                        )}
                        {piattiBar.map((p, i) => <PiattoRow key={i} piatto={p} standNome={stand.nome} />)}
                      </div>
                    )}
                  </div>

                  {/* GIN CORNER */}
                  <div style={{ padding: 0, overflow: "hidden", marginBottom: 8, borderRadius: 14, background: "#fff", border: `2.5px solid #284c62` }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "10px 14px", cursor: "pointer", position: "relative" }} onClick={() => setAperto(aperto === "gin" ? null : "gin")}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <Icon name="cocktail" size={18} color="#284c62" opacity={1} />
                        <div>
                          <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-title)", color: "#284c62", fontWeight: 700, textAlign: "center" }}>GIN CORNER</div>
                          <div style={{ fontSize: "var(--font-meta)", color: C.fuori, fontFamily: "sans-serif", marginTop: 2, textAlign: "center" }}>7 gin premium selezionati</div>
                        </div>
                      </div>
                      <div style={{ position: "absolute", right: 14, top: "50%", transform: `translateY(-50%) ${aperto === "gin" ? "rotate(90deg)" : ""}`, transition: "transform .2s" }}>
                        <Icon name="chevron" size={17} color="#284c62" opacity={0.7} />
                      </div>
                    </div>
                    {aperto === "gin" && (
                      <div style={{ padding: "0 12px 12px", borderTop: "1px solid rgba(40,76,98,0.12)" }}>
                        {GIN_CORNER.map((g, i) => {
                          const qty = getQty(g.nome, "Gin Corner");
                          return (
                            <div key={i} style={{ padding: "10px 0", borderBottom: i < GIN_CORNER.length - 1 ? "1px solid rgba(40,76,98,0.08)" : "none" }}>
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 10, flex: 1, minWidth: 0 }}>
                                  {g.img && (
                                    <div style={{ width: 52, height: 52, flexShrink: 0, background: "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                      <img src={g.img} alt={g.nome} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                                    </div>
                                  )}
                                  <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: "#284c62", fontWeight: 700, marginBottom: 2, textAlign: "left" }}>{g.nome}</div>
                                    <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-meta)", color: "#6b8fa8", lineHeight: 1.5, textAlign: "left" }}>{g.desc}</div>
                                  </div>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
                                  <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: "#284c62", fontWeight: 700 }}>{g.prezzo.toFixed(2)} €</div>
                                  {qty > 0 ? (
                                    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                      <button className="qbtn" onClick={e => { e.stopPropagation(); removeFromCarrello(g.nome, "Gin Corner"); }}><Icon name="minus" size={13} color={C.white} /></button>
                                      <span style={{ fontFamily: "sans-serif", fontWeight: 700, fontSize: "var(--font-body)", minWidth: 18, textAlign: "center", color: "#284c62" }}>{qty}</span>
                                      <button className="qbtn" onClick={e => { e.stopPropagation(); addToCarrello("Gin Corner", g); }}><Icon name="plus" size={13} color={C.white} /></button>
                                    </div>
                                  ) : (
                                    <button className="qbtn" onClick={e => { e.stopPropagation(); addToCarrello("Gin Corner", g); }}><Icon name="plus" size={13} color={C.white} /></button>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>

                  <div style={{ padding: 0, overflow: "hidden", marginBottom: 8, borderRadius: 14, background: "#fff", border: `1.5px solid ${C.fuori}` }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "10px 12px", cursor: "pointer", position: "relative" }} onClick={() => setAperto(aperto === "djset" ? null : "djset")}>
                      <div>
                        <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-title)", color: "#284c62", fontWeight: 700, textAlign: "center" }}>DJ SET</div>
                        <div style={{ fontSize: "var(--font-meta)", color: "#284c62", fontFamily: "sans-serif", marginTop: 2, textAlign: "center" }}>Programma musicale</div>
                      </div>
                      <div style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", gap: 10 }}>
                        <button onClick={e => { e.stopPropagation(); setDjView(v => v === "grid" ? "list" : "grid"); }} style={{ background: "rgba(255, 255, 255, 0.08)", border: '1px solid "#284c62"', borderRadius: 8, cursor: "pointer", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <Icon name={djView === "grid" ? "list" : "grid"} size={14} color="#284c62" opacity={0.7} />
                        </button>
                        <div style={{ transition: "transform .2s", transform: aperto === "djset" ? "rotate(90deg)" : "none", cursor: "pointer", display: "flex", alignItems: "center" }}>
                          <Icon name="chevron" size={17} color="#284c62" opacity={0.7} />
                        </div>
                      </div>
                    </div>
                    {aperto === "djset" && (
                      <div style={{ padding: "0 12px 12px" }}>
                        {djView === "grid" ? (
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "center", marginTop: 10 }}>
                            {SAGRA_DATA.serate.map((s, i) => {
                              const isToday = s.data === new Date().toISOString().split("T")[0];
                              return (
                                <div key={i} style={{ width: "calc(50% - 5px)", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", padding: "12px", background: C.white, border: `1px solid ${C.fuori}`, borderRadius: 14 }}>
                                  {s.imageDj ? (
                                    <div style={{ width: 140, height: 140, borderRadius: 8, marginBottom: 10, overflow: "hidden", background: C.white, border: "1px solid rgba(40,76,98,0.08)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                      <img src={s.imageDj} alt={s.djset} style={{ width: "100%", height: "100%", objectFit: "fill", display: "block" }} />
                                    </div>
                                  ) : (
                                    <div style={{ width: "100%", height: 130, borderRadius: 8, marginBottom: 10, background: C.white, display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(40,76,98,0.08)" }}>
                                      <Icon name="dj" size={20} color={C.green} opacity={0.4} />
                                    </div>
                                  )}
                                  <div style={{ fontSize: "var(--font-meta)", letterSpacing: 2, color: C.green, fontFamily: "sans-serif", textTransform: "uppercase", marginBottom: 4, fontWeight: 600 }}>{s.giorno}</div>
                                  <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-title)", color: C.fuori, marginBottom: 2, fontWeight: 700, lineHeight: 1.2 }}>{s.djset}</div>
                                  {isToday && (
                                    <div style={{ marginTop: 8, background: C.green, color: C.white, borderRadius: 4, padding: "2px 8px", fontSize: "var(--font-small)", fontWeight: 800, fontFamily: "sans-serif", letterSpacing: 1.5, textTransform: "uppercase" }}>Stasera</div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 10 }}>
                            {SAGRA_DATA.serate.map((s, i) => {
                              const isToday = s.data === new Date().toISOString().split("T")[0];
                              return (
                                <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", background: C.white, border: `1px solid ${C.fuori}`, borderRadius: 12 }}>
                                  {s.imageDj ? (
                                    <div style={{ width: 56, height: 70, borderRadius: 8, overflow: "hidden", flexShrink: 0, background: C.white, border: "1px solid rgba(40,76,98,0.08)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                      <img src={s.imageDj} alt={s.djset} style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }} />
                                    </div>
                                  ) : (
                                    <div style={{ width: 56, height: 70, borderRadius: 8, background: C.white, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, border: "1px solid rgba(40,76,98,0.08)" }}>
                                      <Icon name="dj" size={20} color={C.green} opacity={0.4} />
                                    </div>
                                  )}
                                  <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontSize: "var(--font-body)", letterSpacing: 1.5, color: C.green, fontFamily: "sans-serif", textTransform: "uppercase", fontWeight: 600, marginBottom: 2 }}>{s.giorno}</div>
                                    <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-title)", color: C.fuori, fontWeight: 700, lineHeight: 1.2 }}>{s.djset}</div>
                                  </div>
                                  <div style={{ flexShrink: 0, textAlign: "right" }}>
                                    {isToday && (
                                      <div style={{ background: C.green, color: "#000", borderRadius: 4, padding: "2px 6px", fontSize: "var(--font-small)", fontWeight: 800, fontFamily: "sans-serif", letterSpacing: 1.5, textTransform: "uppercase" }}>Stasera</div>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </>
              );
            })()}
          </div>
        )}

        {/* ── SERATE ── */}
        {tab === "serate" && (
          <div style={{ width: "100%" }}>
            <PageTitle
              rightElement={
                <button onClick={() => setSerateView(v => v === "list" ? "grid" : "list")} style={{ background: "rgba(255,255,255,0.05)", border: `1px solid ${C.fuori}`, borderRadius: 10, cursor: "pointer", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center", color: C.white }} title="Cambia vista">
                  <Icon name={serateView === "list" ? "grid" : "list"} size={14} color={C.fuori} />
                </button>
              }
            >MUSICA DAL VIVO CON LE BAND</PageTitle>

            {serateView === "list" ? (
              SAGRA_DATA.serate.map((s, i) => {
                const isToday = s.data === new Date().toISOString().split("T")[0];
                return (
                  <div key={i} className="scard" style={isToday ? { borderColor: C.fuori, borderWidth: 2, background: C.white } : { background: C.white }}>
                    {isToday && (
                      <div style={{ display: "inline-flex", alignItems: "center", gap: 5, background: C.green, color: C.white, borderRadius: 5, padding: "3px 10px", fontSize: "var(--font-small)", fontWeight: 800, fontFamily: "sans-serif", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 9 }}>
                        <div style={{ width: 5, height: 5, borderRadius: "50%", background: C.white }} /> Stasera
                      </div>
                    )}
                    <div style={{ textAlign: "center", marginBottom: 6 }}>
                      <div style={{ fontSize: "var(--font-body)", letterSpacing: 2.5, color: C.fuori, fontFamily: "sans-serif", textTransform: "uppercase", fontWeight: 600 }}>{s.giorno}</div>
                      <div style={{ fontSize: "var(--font-meta)", letterSpacing: 1.5, color: C.fuori, fontFamily: "sans-serif", fontWeight: 500 }}>dalle ore {s.orario}</div>
                    </div>
                    <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-hero)", color: C.green, marginBottom: 3, fontWeight: 700, lineHeight: 1.3, textAlign: "center" }}>{s.artista}</div>
                    {s.image ? (
                      <div style={{ width: "100%", height: 200, borderRadius: 10, marginBottom: 12, overflow: "hidden", background: C.white, border: C.white, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <img src={s.image} alt={s.artista} style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }} />
                      </div>
                    ) : (
                      <div style={{ width: "100%", height: 200, borderRadius: 10, marginBottom: 12, background: "#284c62", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 8 }}>
                        <Icon name="music" size={32} color={C.green} opacity={0.5} />
                      </div>
                    )}
                    {s.note && (
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6, marginBottom: 8, fontSize: "var(--font-meta)", color: C.green, fontFamily: "sans-serif", textAlign: "center" }}>
                        <Icon name="star" size={11} color={C.fuori} />{s.note}
                      </div>
                    )}
                    <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: C.fuori, marginBottom: 12, textAlign: "center" }}>{s.genere}</div>
                    <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: C.green, marginTop: 4 }}>al FuoriSagra dalle ore 19:30 : {s.djset}</div>
                    <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-meta)", color: C.fuori, marginTop: 2 }}>Ogni sera sul palco principale : Baby Dance 19:30–20:30</div>
                  </div>
                );
              })
            ) : (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "center" }}>
                {SAGRA_DATA.serate.map((s, i) => {
                  const isToday = s.data === new Date().toISOString().split("T")[0];
                  return (
                    <div key={i} className="scard" style={{ width: "calc(50% - 5px)", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", padding: "12px", background: C.white, border: `1px solid ${C.fuori}` }}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 5, marginBottom: 4 }}>
                        {isToday && (
                          <div style={{ display: "inline-flex", alignItems: "center", gap: 4, background: C.green, color: C.white, borderRadius: 4, padding: "2px 7px", fontSize: "var(--font-small)", fontWeight: 800, fontFamily: "sans-serif", letterSpacing: 1.5, textTransform: "uppercase", flexShrink: 0 }}>
                            <div style={{ width: 4, height: 4, borderRadius: "50%", background: C.white }} /> Stasera
                          </div>
                        )}
                        <div>
                          <div style={{ fontSize: "var(--font-small)", letterSpacing: 2, color: C.fuori, fontFamily: "sans-serif", textTransform: "uppercase", fontWeight: 600 }}>{s.giorno}</div>
                          <div style={{ fontSize: "var(--font-small)", letterSpacing: 1, color: C.fuori, fontFamily: "sans-serif", fontWeight: 500 }}>dalle ore {s.orario}</div>
                        </div>
                      </div>
                      <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-title)", color: C.green, marginBottom: 3, fontWeight: 700, lineHeight: 1.2 }}>{s.artista}</div>
                      {s.image ? (
                        <div style={{ width: "100%", height: 130, borderRadius: 10, marginBottom: 10, overflow: "hidden", background: C.white, border: C.white, display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <img src={s.image} alt={s.artista} style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }} />
                        </div>
                      ) : (
                        <div style={{ width: "100%", height: 130, borderRadius: 10, marginBottom: 10, background: C.white, display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(40,76,98,0.1)" }}>
                          <Icon name="music" size={20} color={C.green} opacity={0.5} />
                        </div>
                      )}
                      {s.note && (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 5, marginBottom: 6, fontSize: "var(--font-meta)", color: C.green, fontFamily: "sans-serif" }}>
                          <Icon name="star" size={10} color={C.fuori} />{s.note}
                        </div>
                      )}
                      <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: C.fuori, marginBottom: 12 }}>{s.genere}</div>
                      <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-meta)", color: C.green, marginTop: 4 }}>al FuoriSagra dalle ore 19:30 : {s.djset}</div>
                      <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-small)", color: C.fuori, marginTop: 2 }}>Ogni sera palco principale : Baby Dance 19:30–20:30</div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* ── CARRELLO ── */}
        {tab === "carrello" && (
          <div style={{ width: "100%" }}>
            <PageTitle rightElement={
              <button onClick={() => setShowCasseModal(true)} style={{ background: C.white, border: "1px solid ${C.fuori}", borderRadius: 8, cursor: "pointer", width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center" }} title="Guida alle Casse">
                <Icon name="info" size={15} color={C.fuori} />
              </button>
            }>Simula la spesa</PageTitle>
            {carrello.length === 0 ? (
              <div style={{ textAlign: "center", padding: "40px 20px", color: C.muted, fontFamily: "sans-serif" }}>
                <div style={{ display: "flex", justifyContent: "center", marginBottom: 14, opacity: .2 }}>
                  <Icon name="cart" size={54} color={C.fuori} background={C.white} />
                </div>
                <div style={{ lineHeight: 1.9, fontSize: "var(--font-body)", color: C.fuori }}>Nessun piatto aggiunto.</div>
                <button className="btn" style={{ marginTop: 18, padding: "10px 22px", border: "1.5px solid #fff" }} onClick={() => setTab("menu")}>Vai al Menù</button>
              </div>
            ) : (
              <>
                {carrello.map((item, i) => (
                  <div key={i} className="card" style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px" }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: "#284c62", lineHeight: 1.4, textAlign: "left" }}>{item.nome}</div>
                      <div style={{ fontSize: "var(--font-meta)", color: C.fuori, fontFamily: "sans-serif", marginTop: 2, textAlign: "left" }}>{item.stand}</div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 7, flexShrink: 0 }}>
                      <button className="qbtn" onClick={() => removeFromCarrello(item.nome, item.stand)}><Icon name="minus" size={13} color={C.white} /></button>
                      <span style={{ fontFamily: "sans-serif", fontWeight: 700, fontSize: "var(--font-title)", minWidth: 18, textAlign: "center", color: "#284c62" }}>{item.qty}</span>
                      <button className="qbtn" onClick={() => addToCarrello(item.stand, item)}><Icon name="plus" size={13} color={C.white} /></button>
                    </div>
                    <div style={{ fontFamily: "sans-serif", fontWeight: 700, color: C.fuori, fontSize: "var(--font-body)", minWidth: 48, textAlign: "right", flexShrink: 0 }}>{fmtP(item.prezzo * item.qty)}</div>
                  </div>
                ))}
                {/* Stand breakdown */}
                <div style={{ background: "rgba(40,76,98,0.04)", border: "1px solid rgba(40,76,98,0.1)", borderRadius: 14, padding: "12px 14px", marginBottom: 8, marginTop: 8 }}>
                  <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-meta)", fontWeight: 700, color: "#284c62", textTransform: "uppercase", letterSpacing: 0.8, marginBottom: 8, textAlign: "left" }}>
                    Dettaglio piatti per stand:
                  </div>
                  {Object.entries(
                    carrello.reduce((acc, item) => {
                      acc[item.stand] = (acc[item.stand] || 0) + item.qty;
                      return acc;
                    }, {})
                  ).map(([standName, qty]) => (
                    <div key={standName} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: "1px dashed rgba(40,76,98,0.1)" }}>
                      <span style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: "#284c62", fontWeight: 500 }}>{standName}</span>
                      <span style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: C.green, fontWeight: 700 }}>{qty} {qty === 1 ? "piatto" : "piatti"}</span>
                    </div>
                  ))}
                </div>

                <div style={{ background: "rgba(141,181,42,0.07)", border: `1px solid ${C.borderG}`, borderRadius: 16, padding: "18px 18px", marginTop: 6, textAlign: "center" }}>
                  <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: C.fuori, textAlign: "center", marginBottom: 5 }}>{totPezzi} {totPezzi === 1 ? "piatto" : "piatti"}</div>
                  <div style={{ fontFamily: "sans-serif", fontSize: "clamp(32px, 9vw, 48px)", color: C.fuori, textAlign: "center", fontWeight: 900, letterSpacing: -1 }}>{totale.toFixed(2)} €</div>
                  <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: C.fuori, marginTop: 4, textAlign: "center" }}>Totale stimato</div>
                </div>
                <button style={{ width: "100%", padding: "10px", marginTop: 8, borderRadius: 11, background: C.white, border: `1px solid ${C.fuori}`, color: C.fuori, fontFamily: "sans-serif", fontSize: "var(--font-body)", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 7 }} onClick={() => setCarrello([])}>
                  <Icon name="trash" size={13} color={C.fuori} />Svuota lista
                </button>
              </>
            )}

          </div>
        )}

        {/* ── CHAT ── */}
        {tab === "chat" && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", flex: 1, minHeight: 0 }}>
            <PageTitle rightElement={
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ fontSize: "var(--font-small)", fontFamily: "sans-serif", color: "#284c62", fontWeight: 600 }}>ITA</span>
                <div onClick={() => setDialectMode(d => !d)} style={{ width: 38, height: 20, borderRadius: 10, background: dialectMode ? C.green : "rgba(40,76,98,0.15)", cursor: "pointer", position: "relative", transition: "background .2s", flexShrink: 0, border: "1.5px solid rgba(40,76,98,0.2)" }}>
                  <div style={{ width: 14, height: 14, borderRadius: "50%", background: "#fff", position: "absolute", top: 2, left: dialectMode ? 20 : 2, transition: "left .2s", boxShadow: "0 1px 3px rgba(0,0,0,0.25)" }} />
                </div>
                <span style={{ fontSize: "var(--font-small)", fontFamily: "sans-serif", color: dialectMode ? C.green : "#284c62", fontWeight: dialectMode ? 800 : 600 }}>VEN 🦁</span>
              </div>

            }>Assistente BECCUP-AI</PageTitle>
            {dialectMode && (
              <div style={{ background: "rgba(45,186,81,0.1)", border: "1px solid rgba(45,186,81,0.3)", borderRadius: 10, padding: "6px 12px", marginBottom: 8, fontFamily: "sans-serif", fontSize: "var(--font-meta)", color: C.green, textAlign: "center" }}>
                🦁 Modo veronese attivo — l'assistente risponde in dialetto!
              </div>
            )}
            {/* messages area */}
            <div style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", gap: 11, paddingBottom: 8, WebkitOverflowScrolling: "touch" }}>
              {chatMessages.map((msg, i) => (
                <div key={i} style={{ display: "flex", justifyContent: msg.role === "user" ? "flex-end" : "flex-start", alignItems: "flex-end", gap: 8 }}>
                  {msg.role === "assistant" && (
                    <div style={{ width: 28, height: 28, flexShrink: 0 }}>
                      <img src={OWL_GIF} alt="beccupAI" style={{ background: C.fuori, width: 36, height: 36, objectFit: "fill", flexShrink: 0, borderRadius: 6, cursor: "pointer" }}></img>
                    </div>
                  )}
                  <div style={{
                    ...(msg.role === "user"
                      ? { background: "#284c62", color: "#fff", borderRadius: "18px 18px 4px 18px", marginLeft: "auto" }
                      : { background: "#fff", border: "1px solid #284c62", color: "#284c62", borderRadius: "18px 18px 18px 4px" }),
                    padding: "10px 14px", maxWidth: "82%", fontFamily: "sans-serif", fontSize: "var(--font-body)", lineHeight: 1.55, whiteSpace: "pre-wrap"
                  }}>{msg.content}</div>
                </div>
              ))}
              {chatLoading && (
                <div style={{ display: "flex", alignItems: "flex-end", gap: 8 }}>
                  <div style={{ width: 28, height: 28, flexShrink: 0 }}>
                    <img src={OWL_GIF} alt="beccupAI" style={{ background: C.fuori, width: 36, height: 36, objectFit: "contain", flexShrink: 0, borderRadius: 6, cursor: "pointer" }}></img>
                  </div>
                  <div style={{ background: "#fff", border: "1px solid #284c62", borderRadius: "18px 18px 18px 4px", padding: "10px 14px", fontFamily: "sans-serif", fontSize: "var(--font-body)" }}>
                    <span className="blink" style={{ animationDelay: "0ms", color: "#284c62" }}>●</span>{" "}
                    <span className="blink" style={{ animationDelay: "200ms", color: "#284c62" }}>●</span>{" "}
                    <span className="blink" style={{ animationDelay: "400ms", color: "#284c62" }}>●</span>
                  </div>
                </div>
              )}
              <div ref={chatEndRef} />
            </div>
          </div>
        )}

        {/* ── ASSOCIAZIONI ── */}
        {tab === "associazioni" && (
          <div style={{ width: "100%" }}>
            <PageTitle>ASSOCIAZIONI</PageTitle>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "center" }}>
              {SAGRA_DATA.associazioni.map((ass, i) => (
                <div key={i} className="scard" style={{ width: "calc(50% - 5px)", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", padding: "12px", background: "#fff", border: `1px solid ${C.fuori}` }}>
                  {ass.immagine ? (
                    <div style={{ width: "100%", height: 110, borderRadius: 10, marginBottom: 10, overflow: "hidden", background: "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <img src={ass.immagine} alt={ass.nome} style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }} />
                    </div>
                  ) : (
                    <div style={{ width: "100%", height: 110, borderRadius: 10, marginBottom: 10, background: "#284c62", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <Icon name="group" size={28} color={C.green} opacity={0.5} />
                    </div>
                  )}
                  <div style={{ fontFamily: "sans-serif", fontSize: "var(--font-body)", color: C.green, fontWeight: 700, lineHeight: 1.3 }}>{ass.descrizione}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* ── CHAT INPUT — in-flow, la nav fixed si sovrappone ma l'input resta visibile ── */}
      {tab === "chat" && (
        <div style={{ flexShrink: 0, padding: "8px 12px 8px", background: C.bg, borderTop: "1px solid rgba(40,76,98,0.1)" }}>
          <div style={{ display: "flex", gap: 6, marginBottom: 7, overflowX: "auto", paddingBottom: 2, WebkitOverflowScrolling: "touch" }}>
            {["Vegetariano?", "Chi suona sabato?", "Dove sono le birre?", "Cos'è l'Happy Sagra?", "Polenta + vino?"].map(s => (
              <button key={s} style={{ background: "#fff", border: "1px solid #284c62", color: "#284c62", borderRadius: 20, padding: "5px 12px", fontSize: "var(--font-meta)", fontFamily: "sans-serif", cursor: "pointer", whiteSpace: "nowrap", flexShrink: 0 }} onClick={() => setChatInput(s)}>{s}</button>
            ))}
          </div>
          <div style={{ display: "flex", gap: 7 }}>
            <input
              value={chatInput}
              onChange={e => setChatInput(e.target.value)}
              onKeyDown={e => e.key === "Enter" && sendChat()}
              placeholder="Chiedimi qualcosa sulla sagra…"
              disabled={chatLoading}
              style={{ background: "#fff", border: "1px solid #284c62", borderRadius: 11, color: "#284c62", fontFamily: "sans-serif", fontSize: "var(--font-title)", outline: "none", padding: "10px 14px", width: "100%", WebkitAppearance: "none" }}
            />
            <button className="btn" onClick={sendChat} disabled={chatLoading} style={{ flexShrink: 0, padding: "10px 14px", borderRadius: 10, display: "flex", alignItems: "center" }}>
              {chatLoading ? "…" : <Icon name="send" size={15} color="#fff" />}
            </button>
          </div>
        </div>
      )}

      {/* ── BOTTOM NAV ── */}
      <div style={{ flexShrink: 0, width: "100%", background: "#284c62", display: "flex", zIndex: 100 }}>
        {navTabs.map(t => {
          const active = tab === t.id;
          return (
            <button key={t.id} onClick={() => setTab(t.id)} style={{ flex: 1, background: "none", border: "none", padding: "6px 4px 6px", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: 3, position: "relative" }}>
              {t.id === "carrello" && totPezzi > 0 && (
                <div style={{ position: "absolute", top: 4, right: "calc(50% - 17px)", background: C.green, color: "#fff", borderRadius: "50%", width: 15, height: 15, fontSize: "var(--font-small)", fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "sans-serif", zIndex: 1 }}>{totPezzi}</div>
              )}
              <div style={{
                display: "flex", flexDirection: "column", alignItems: "center", gap: 2,
                background: active ? C.green : "transparent",
                borderRadius: active ? 10 : 0,
                padding: active ? "4px 8px" : "4px 4px",
                transition: "background .15s, border-radius .15s",
              }}>
                <Icon name={t.icon} size={19} color={active ? "#284c62" : C.green} opacity={active ? 1 : 0.85} />
                <span style={{ fontSize: "var(--font-small)", fontFamily: "sans-serif", color: active ? "#284c62" : C.green, fontWeight: active ? 800 : 500, letterSpacing: .6, textTransform: "uppercase", whiteSpace: "nowrap" }}>{t.label}</span>
              </div>
            </button>
          );
        })}
      </div>

      {showCasseModal && <CassaModal onClose={() => setShowCasseModal(false)} />}
      {showAllergeniModal && <AllergeniModal onClose={() => setShowAllergeniModal(false)} />}
      {showWelcome && (
        <WelcomeModal onClose={() => {
          localStorage.setItem(WELCOME_KEY, "1");
          setShowWelcome(false);
        }} />
      )}
      {!showWelcome && showDaily && <DailyEventModal onClose={() => setShowDaily(false)} />}
    </div>
  );
}